var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.summary)?_c('SummaryEvent',{attrs:{"event":_vm.event}}):_c('DetailEvent',{attrs:{"event":_vm.event}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }